<template>
  <v-list-item-group>
    <v-list-item
      v-for="(menu, i) in menuList"
      :key="i"
      class="px-5"
      @click="selectMenu(menu)"
    >
      <appl-menu-icon
        :propsParam="{
          applCd: menu.applCd,
          gntGubunCd: menu.gntGubunCd,
        }"
      />

      <v-list-item-content>
        <v-list-item-title
          class="menu-title"
          v-text="menu.menuNm"
        ></v-list-item-title>
      </v-list-item-content>

      <v-list-item-icon>
        <v-icon>mdi-chevron-right</v-icon>
      </v-list-item-icon>
    </v-list-item>
  </v-list-item-group>
</template>

<script>
/* 신청서 하위메뉴 컴포넌트 */
import ApplMenuIcon from '@/components/application/form/ApplMenuIcon.vue';
import dayjs from 'dayjs';
import routerNames from '@/const/routerConstants';

export default {
  props: {
    menuList: Array,
  },

  computed: {
    todayYMD() {
      return dayjs().format('YYYYMMDD');
    },
  },

  methods: {
    /* 신청서 데이터 초기화 및 화면 이동 */
    async selectMenu(menu) {
      this.$store.commit('SET_CODE', menu.code);
      this.$store.commit('SET_APPL_CD', menu.applCd);

      const applParam = {
        applCd: menu.applCd,
        gntGubunCd: menu.gntGubunCd,
      };

      const applicationCdList = menu.applCd.split(',');
        if(applicationCdList.length > 1 && menu.menuCd === '302'){
          this.$router.push({
            name : routerNames.ReCertAppStep
            , params : {
              applCd: menu.applCd
              , gntGubunCd: menu.gntGubunCd
            }
          });

          return;
        }else if(applicationCdList.length > 1 && menu.menuCd !== '302'){
          this.$router.push({
            name : routerNames.LeaAbsAppStep1
            , params : {
              applCd: menu.applCd
              , gntGubunCd: menu.gntGubunCd
            }
          });

          return;
        }

      const routerName = await this.$store.dispatch(
        'ELA/FETCH_MENU_ACTION',
        applParam,
      );
      this.$router.push(routerName);
    },
  },

  components: {
    ApplMenuIcon, // 신청서아이콘
  },
};
</script>

<style></style>
